import ForgotPasswordPage from "modules/auth/pages/ForgotPasswordPage";
import LoginPage from "modules/auth/pages/LoginPage";
import RegisterPage from "modules/auth/pages/RegisterPage";
import ConfirmRoutePage from "modules/client/active-orders/pages/ConfirmRoutePage";
import ClientCreateOrderPage from "modules/client/active-orders/pages/ClientCreateOrderPage";
import JobDetail from "modules/client/active-orders/pages/JobDetail";
import AddJob from "modules/client/active-orders/pages/AddJob";
import OrderRouteDetailPage from "modules/client/active-orders/pages/OrderRouteDetailPage";
import DriverCreatePasswordPage from "modules/client/drivers/pages/DriverCreatePasswordPage";
import DriveRegisterSuccessPage from "modules/client/drivers/pages/DriveRegisterSuccessPage";
import DriverRegisterPage from "modules/client/drivers/pages/DriverRegisterPage";
import RouteHistoryListPage from "modules/client/history/pages/RouteHistoryListPage";
import InternalDriverListPage from "modules/client/internal-drivers/pages/InternalDriverListPage";
import RouteDetailPage from "modules/client/routes/pages/RouteDetailPage";
import RouteDispatchPage from "modules/client/routes/pages/RouteDispatchPage";
import RouteListPage from "modules/client/routes/pages/RouteListPage";
import MyProfilePage from "modules/client/settings/pages/MyProfilePage";
import NotificationSetting from "modules/client/settings/pages/NotificationSetting";
import RouteOptionsPage from "modules/client/settings/pages/RouteOptionsPage";
import ChangePassword from "modules/client/settings/pages/ChangePassword";
import CompanySettingsPage from "modules/client/settings/pages/CompanySettingsPage";
import APIKeyPage from "modules/client/profile/pages/APIKey";
import EditStopPage from "modules/admin/orders/pages/EditStop";
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PrivateUserRoute from "routes/PrivateUserRoute";
import OnGoingPage from "../../modules/client/on-going/pages/OnGoingPage";
import ValidationPage from "../../modules/client/validations/ValidationSection";
import DashboardPage from "../../modules/client/dashboard";
import ClientSftpPodReport from "modules/client/reports/pages/SftpPodReport";
import DriverFeedbackPage from "modules/client/driver-feedback/pages/DriverFeedback";
import InternalDriverFeedbacksPage from "modules/client/driver-feedback/pages/InternalDriverFeedbacksPage";
import ClientUserListPage from "modules/client/client-users/pages/ClientUserListPage";
import WelcomePage from "modules/auth/pages/WelcomePage";
import FlexioPoolList from "modules/client/pool/pages/FlexioPoolList";
import { PoolInvoices } from "modules/client/pool/pages/PoolInvoices";
import { Alert, Col, Row } from "antd";
import { useSelector } from "react-redux";
import { selectRole } from "modules/auth/store/authSlice";
import { UserRole } from "configs/constants";
import CreatePoolOrderPage from "modules/shared/CreatePoolOrderPage";
import Locations from "modules/client/settings/pages/Locations";
import LocationDetail from "modules/client/settings/pages/LocationDetail";
import ResellerDashboardPage from "modules/client/reseller-dashboard";
import HomePage from "modules/client/home/pages/HomePage";
import PoolTracking from "modules/client/on-going/pages/PoolTracking";
import ImportRoute from "modules/client/import-route/pages/ImportRoute";
import BillingDashboard from "modules/client/billing/pages/BillingDashboard";
import ClientFacturasList from "modules/client/billing/pages/ClientFacturasList";
import ClientFacturaDetail from "modules/client/billing/pages/ClientFacturaDetail";
import UpgradesPage from "modules/client/billing/pages/UpgradesPage";
import PlansPage from "modules/client/billing/pages/PlansPage";
import SubscriptionsPage from "modules/client/settings/pages/SubscriptionsPage";
import PaymentMethodPage from "modules/client/settings/pages/PaymentMethodPage";
import WarehousesPage from "modules/client/warehouses/pages/WarehousesPage";
import CreateWarehousePage from "modules/client/warehouses/pages/CreateWarehousePage";
import EditWarehousePage from "modules/client/warehouses/pages/EditWarehousePage";
import WarehouseInventoryPage from "modules/client/warehouses/pages/WarehouseInventoryPage";
import EditInventoryItemPage from "modules/client/warehouses/pages/EditInventoryItemPage";
import CreateInventoryItemPage from "modules/client/warehouses/pages/CreateInventoryItemPage";
import InventoryItemDetailPage from "modules/client/warehouses/pages/InventoryItemDetailPage";
import WarehouseSettingsPage from "modules/client/warehouses/pages/WarehouseSettingsPage";
import EntitlementProtectedRoute from "routes/EntitlementProtectedRoute";
import { ENTITLEMENT_IDS } from "configs/entitlements";
import PurchaseOrdersPage from "modules/client/purchase-orders/pages/PurchaseOrdersPage";
import PublicPurchaseOrderPage from "modules/public/purchase-order/pages/PublicPurchaseOrderPage";
import ClientPlanListPage from "modules/client/plans/pages/PlanListPage";
import ClientRoutePlanDetailPage from "modules/client/plans/pages/RoutePlanDetailPage";
import ClientToteDetailPage from "modules/client/scan2pack/pages/ToteDetailPage";
import ClientSavedRoutesPage from "modules/client/saved-routes/pages/SavedRoutesPage";
import CreateDeliveryPlanPage from "modules/client/delivery-plan/pages/CreateDeliveryPlanPage";
import AIImportPage from "modules/client/ai-import/pages/AIImportPage";
import ImportFilePage from "modules/client/import-file/pages/ImportFilePage";
import ClientScan2PackPage from "modules/client/scan2pack/pages/Scan2PackPage";

const ClientSpace = () => {
  const role = useSelector(selectRole);
  return (
    <Switch>
      <Route
        exact
        path="/:clientId/purchaseorder/new"
        component={PublicPurchaseOrderPage}
      />
      <Route exact path="/s/:token" component={OnGoingPage} />
      <Route exact path="/tracking/:token" component={PoolTracking} />
      <Route exact path="/s/dfb/:jobId" component={DriverFeedbackPage} />
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/" component={LoginPage} />
      <Route exact path="/forgot-password" component={ForgotPasswordPage} />
      <Route exact path="/register" component={RegisterPage} />
      <Route exact path="/welcome" component={WelcomePage} />
      <Route
        exact
        path="/drivers/register"
        render={() => {
          window.location.replace("/driver/register");
          return null;
        }}
      />
      <Route
        exact
        path="/drivers/register/success"
        component={DriveRegisterSuccessPage}
      />
      <Route exact path="/drivers/create-password" component={DriverCreatePasswordPage} />
      <Route
        exact
        path="/paymentMethodAdded"
        component={() => {
          setTimeout(() => {
            window.open("/settings/my-profile", "_self");
          }, 5000);
          return (
            <Row>
              <Col span={8}></Col>
              <Col span={8}>
                <Alert
                  message="Success"
                  description="Payment method added successfully. You will be redirected..."
                  type="success"
                  className="mt-4"
                  showIcon
                />
              </Col>
              <Col span={8}></Col>
            </Row>
          );
        }}
      />
      <Route
        exact
        path="/paymentMethodEdited"
        component={() => {
          setTimeout(() => {
            window.open("/settings/my-profile", "_self");
          }, 5000);
          return (
            <Row>
              <Col span={8}></Col>
              <Col span={8}>
                <Alert
                  message="Success"
                  description="Payment method edited successfully. You will be redirected..."
                  type="success"
                  className="mt-4"
                  showIcon
                />
              </Col>
              <Col span={8}></Col>
            </Row>
          );
        }}
      />
      <PrivateUserRoute exact path="/locations" component={Locations} />
      <PrivateUserRoute exact path="/locations/:locationId" component={LocationDetail} />
      <PrivateUserRoute exact path="/history" component={RouteHistoryListPage} />
      <PrivateUserRoute exact path="/delivery-plan" component={CreateDeliveryPlanPage} />
      <EntitlementProtectedRoute
        exact
        path="/ai-import"
        component={AIImportPage}
        entitlementId={ENTITLEMENT_IDS.AI_IMPORT}
        redirectTo="/billing/upgrades"
      />
      <PrivateUserRoute exact path="/routes" component={RouteListPage} />
      <PrivateUserRoute exact path="/plans" component={ClientPlanListPage} />
      <PrivateUserRoute exact path="/scan2pack" component={ClientScan2PackPage} />
      <PrivateUserRoute
        exact
        path="/routeplan/:id"
        component={ClientRoutePlanDetailPage}
      />
      <PrivateUserRoute exact path="/tote/:id" component={ClientToteDetailPage} />
      <PrivateUserRoute exact path="/saved-routes" component={ClientSavedRoutesPage} />
      <PrivateUserRoute exact path="/import-file" component={ImportFilePage} />
      <PrivateUserRoute exact path="/routes/:id" component={RouteDetailPage} />
      <PrivateUserRoute exact path="/routes/:id/dispatch" component={RouteDispatchPage} />
      <PrivateUserRoute exact path="/routes/:id/:eid" component={JobDetail} />
      <PrivateUserRoute exact path="/routes/:id/:eid/add-job" component={AddJob} />
      <PrivateUserRoute
        exact
        path="/routes/:routeId/stops/:id/edit"
        component={EditStopPage}
      />
      <PrivateUserRoute exact path="/orders/new" component={ClientCreateOrderPage} />
      <Route exact path="/pool-orders/new" render={() => <Redirect to="/home" />} />
      <PrivateUserRoute exact path="/billing/pool-invoices" component={PoolInvoices} />
      <PrivateUserRoute exact path="/orders/confirm-route" component={ConfirmRoutePage} />
      {/* <PrivateUserRoute exact path="/orders" component={OrderList} /> */}
      <PrivateUserRoute
        exact
        path="/orders/:id/routes"
        component={OrderRouteDetailPage}
      />
      <PrivateUserRoute exact path="/drivers" component={InternalDriverListPage} />
      <Route
        exact
        path="/settings"
        render={() => {
          window.location.replace("/settings/my-profile");
          return null;
        }}
      />
      <PrivateUserRoute exact path="/settings/my-profile" component={MyProfilePage} />
      <PrivateUserRoute
        exact
        path="/settings/notification"
        component={NotificationSetting}
      />
      <PrivateUserRoute exact path="/settings/validations" component={ValidationPage} />
      <Route exact path="/settings/routing-process">
        <Redirect to="/settings/route-options" />
      </Route>
      <Route exact path="/settings/return-process">
        <Redirect to="/settings/route-options" />
      </Route>
      <PrivateUserRoute
        exact
        path="/settings/route-options"
        component={RouteOptionsPage}
      />
      <PrivateUserRoute
        exact
        path="/settings/change-password"
        component={ChangePassword}
      />
      <PrivateUserRoute
        exact
        path="/settings/company-settings"
        component={CompanySettingsPage}
      />
      <PrivateUserRoute exact path="/validations" component={ValidationPage} />
      <PrivateUserRoute exact path="/api-key" component={APIKeyPage} />
      <PrivateUserRoute exact path="/dashboard" component={DashboardPage} />
      <PrivateUserRoute exact path="/reports/sftp-pod" component={ClientSftpPodReport} />
      <PrivateUserRoute exact path="/home" component={HomePage} />
      <PrivateUserRoute
        exact
        path="/reseller/dashboard"
        component={ResellerDashboardPage}
      />
      <PrivateUserRoute exact path="/feedbacks" component={InternalDriverFeedbacksPage} />
      {role === UserRole.ADMIN && (
        <PrivateUserRoute exact path="/client-users" component={ClientUserListPage} />
      )}
      <PrivateUserRoute exact path="/pool" component={FlexioPoolList} />
      <PrivateUserRoute exact path="/import-route" component={ImportRoute} />
      <PrivateUserRoute
        exact
        path="/billing"
        render={() => {
          window.location.replace("/billing/dashboard");
          return null;
        }}
      />
      <PrivateUserRoute exact path="/billing/dashboard" component={BillingDashboard} />
      <PrivateUserRoute exact path="/billing/plans" component={PlansPage} />
      <PrivateUserRoute exact path="/billing/upgrades" component={UpgradesPage} />
      <PrivateUserRoute exact path="/billing/facturas" component={ClientFacturasList} />
      <PrivateUserRoute
        exact
        path="/billing/facturas/:id"
        component={ClientFacturaDetail}
      />
      <Route exact path="/billing/invoicing">
        <Redirect to="/billing/dashboard" />
      </Route>
      <PrivateUserRoute
        exact
        path="/billing/subscriptions"
        component={SubscriptionsPage}
      />
      <PrivateUserRoute
        exact
        path="/billing/payment-method"
        component={PaymentMethodPage}
      />
      <EntitlementProtectedRoute
        exact
        path="/warehouses"
        component={WarehousesPage}
        entitlementId={ENTITLEMENT_IDS.WAREHOUSE}
        redirectTo="/home"
      />
      <EntitlementProtectedRoute
        exact
        path="/warehouses/settings"
        component={WarehouseSettingsPage}
        entitlementId={ENTITLEMENT_IDS.WAREHOUSE}
        redirectTo="/home"
      />
      <EntitlementProtectedRoute
        exact
        path="/warehouses/creation"
        component={CreateWarehousePage}
        entitlementId={ENTITLEMENT_IDS.WAREHOUSE}
        redirectTo="/home"
      />
      <EntitlementProtectedRoute
        exact
        path="/warehouses/edit/:warehouseId"
        component={EditWarehousePage}
        entitlementId={ENTITLEMENT_IDS.WAREHOUSE}
        redirectTo="/home"
      />
      <EntitlementProtectedRoute
        exact
        path="/warehouses/:inventoryId"
        component={WarehouseInventoryPage}
        entitlementId={ENTITLEMENT_IDS.WAREHOUSE}
        redirectTo="/home"
      />
      <EntitlementProtectedRoute
        exact
        path="/warehouses/:inventoryId/item-details/:itemId"
        component={InventoryItemDetailPage}
        entitlementId={ENTITLEMENT_IDS.WAREHOUSE}
        redirectTo="/home"
      />
      <EntitlementProtectedRoute
        exact
        path="/warehouses/:inventoryId/edit/:itemId"
        component={EditInventoryItemPage}
        entitlementId={ENTITLEMENT_IDS.WAREHOUSE}
        redirectTo="/home"
      />
      <EntitlementProtectedRoute
        exact
        path="/warehouses/inventory/creation/:warehouseId"
        component={CreateInventoryItemPage}
        entitlementId={ENTITLEMENT_IDS.WAREHOUSE}
        redirectTo="/home"
      />
      <EntitlementProtectedRoute
        exact
        path="/purchaseorders"
        component={PurchaseOrdersPage}
        entitlementId={ENTITLEMENT_IDS.PURCHASE_ORDER}
        redirectTo="/billing/plans"
      />
    </Switch>
  );
};
export default ClientSpace;
